import { textsFor, type Texts } from "@digitalisation/enlixy-comp";

/**
 * The cockpit addresses its users formally in German ("Sie"); these package
 * texts say "du" (help and tours, the error and access pages, the assistant).
 */
export const FORMAL_GERMAN: Partial<Texts> = {
  loadErrorText:
    "Ein Teil der Anwendung ließ sich nicht laden, meist weil gerade eine neue Version eingespielt wurde oder die Anmeldung abgelaufen ist. Neu laden behebt das; Ihre Arbeit ist gespeichert.",
  assistantPlaceholder: "Fragen Sie den KI-Assistenten …",
  assistantEmptyText: "Vorschläge führen Sie selbst per Klick aus.",
  tourTryIt: "Probieren Sie es aus:",
  helpNoResults: "Nichts gefunden. Versuchen Sie ein anderes Wort.",
  pathTitle: "Ihr Lernpfad",
  pathMoodStart:
    "Jede Aufgabe dauert nur einen Moment. Die meisten erledigen Sie einfach beim Arbeiten.",
  pathMoodDone: "Alles gelernt. Sie kennen jetzt jede Funktion.",
  toursIntro:
    "Eine Tour hebt Bereich für Bereich hervor und erklärt ihn direkt in der Anwendung. Während der Tour sind Knöpfe gesperrt, Sie können also nichts versehentlich auslösen. Mit [→] und [←] blättern Sie, [Esc] beendet die Tour.",
  articleTourText: "Lieber zeigen lassen? Die Tour führt Sie durch diesen Bereich.",
  learnedAllText: "Sie kennen jetzt jede Funktion.",
  noAccessText:
    "Die Anmeldung hat geklappt, aber Ihrem Konto ist noch keine Rolle für diese Anwendung zugewiesen.",
  howToAccess: "So bekommen Sie Zugriff",
};

/** The package texts in the cockpit's language (German formal). */
export function cockpitTexts(language: string): Texts {
  const texts = textsFor(language);
  return language.toLowerCase().startsWith("de") ? { ...texts, ...FORMAL_GERMAN } : texts;
}
